// extracted by mini-css-extract-plugin
export default {"teacher":"Teacher_teacher__UjXe-","title":"Teacher_title__HnybC","search":"Teacher_search__yeyuD"};